import axiosJava from "@/api/config_java";

export function metaFeedBack(meta_utm) {
  return axiosJava.get("/am/api/client/clue/feedback?metaUtm=" + meta_utm);
}


/**
 * 营销中心-新增客户线索
 * @param {object} params 
 * @param {string} params.clientCompanyName
 * @param {string} params.clientCompanyId
 * @param {string} params.contactName
 * @param {string} params.mobilePrefix
 * @param {string} params.mobileNumber
 * @param {string} params.industryId
 * @param {string} params.metaUtm
 * @returns 
 */
export function metaClueAdd(params){
  return axiosJava.post("/am/api/client/clue/add",params)
}